import Image from 'next/image'
import Link from 'next/link'
import { A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { BASE_URL } from '@/shared/lib/const/env'

import cl from './style.module.scss'

export interface BrandsItem {
	NAME: string
	CODE: string
	IMAGE: string
}

export const BrandsSwiper = (props: { items: BrandsItem[] }) => {
	const { items } = props

	return (
		<Swiper modules={[A11y]} slidesPerView={'auto'} spaceBetween={24} className={cl.swiper}>
			{items?.map(({ NAME, CODE, IMAGE }) => (
				<SwiperSlide className={cl.slide} key={NAME}>
					<Link prefetch={false} href={`/brand/${CODE}`}>
						<Image src={BASE_URL + IMAGE} width={200} height={120} alt={''} className={cl.img} />
					</Link>
				</SwiperSlide>
			))}
		</Swiper>
	)
}
